import React, { useState } from "react";
import { Link } from "react-router-dom";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import useApi from "../../../core/customhook/useApi";
import Loader from "../../../core/common/selfLoder";

const Downloadecard = () => {
  const {
    data: EcardData,
    loading: EcardLoading,
    error: ecardError,
  } = useApi("/api/insurance-ecard", {
    method: "GET",
    autoCall: true,
  });

  return (
    <>
      <Loader loading={EcardLoading} />
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Download e-card</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/employee-dashboard">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Download e-card
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}

          {EcardData === undefined ? (
            // ⏳ Loading state
            <div className="card p-5 shadow-sm text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : EcardData?.data === null ? (
            // ❌ No data
            <div className="card p-5 shadow-sm">
              <p className="text-center fs-25">
                For now, you are not a part of Team1’s health insurance plan. If
                you want to become a member for the same, please click on the
                below link to know your eligibility.
              </p>

              <Link to="/premium-eligibility" className="btn btn-primary mt-3">
                Premium Eligibility
              </Link>
            </div>
          ) : (
            // ✅ Show E-Card
            <div className="card p-2 d-flex justify-content-center align-items-center">
              <div className="col-md-4 mt-4">
                <div className="card">
                  <div className="card-header">
                    <div className="d-flex align-items-center w-100">
                      <ImageWithBasePath
                        src={
                          EcardData?.data?.photo ||
                          "assets/img/profiles/avatar-01.jpg"
                        }
                        alt="img"
                        className="avatar avatar-rounded me-2"
                      />
                      <div>
                        <div className="fs-15 fw-semibold">
                          {EcardData?.data?.employee_name}
                        </div>
                        <p className="mb-0 text-muted fs-11">
                          {EcardData?.data?.email_id}
                        </p>
                      </div>
                      <div className="dropdown ms-auto">
                        <a
                          href={EcardData?.data?.e_card}
                          className="btn btn-icon btn-sm btn-light"
                          target="_blank"
                          download
                          rel="noopener noreferrer"
                        >
                          <i className="fa-solid fa-download" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="card-body text-center">
                    <p>
                      Download your personalized E-card and share the
                      appreciation! Click the button below to save the card to
                      your device.
                    </p>
                    <a
                      href={EcardData?.data?.e_card}
                      download
                      className="btn btn-primary custom_button"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa-solid fa-download me-2"></i>
                      Download E-Card
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default Downloadecard;
